import { _scrollTo, isVisible } from '@app/utils/domHelpers'

import { useHighlightedCard } from '@app/shared/pinia/highlighted-card'

export default {
  created() {
    window.eventHub.$on('clearAnchor', this.clearAnchor)
    window.eventHub.$on('scrollToElement', this.setAnchor)
    window.eventHub.$on('highlightRemark', this.highlightCardBeforeScroll)
  },

  updated() {
    // Handle anchor scolling if data is of communication element type and if hasn't been scrolled once.
    if (
      !this.anchorElementScrolled &&
      this.isCommunicationAnchored() &&
      this.isElementVisible()
    ) {
      this.handleAnchorScroll()
    }
  },

  beforeUnmount() {
    window.eventHub.$off('clearAnchor', this.clearAnchor)
    window.eventHub.$off('scrollToElement', this.setAnchor)
    window.eventHub.$off('highlightRemark', this.highlightCardBeforeScroll)
  },

  methods: {
    elementAnchorLink() {
      return this.hash || window.location.hash
    },

    setAnchor({ elementType, elementId, force } = { force: false }) {
      this.anchorElementScrolled = false

      if (force) {
        this.hash = '#' + elementType + '-' + elementId
        if (
          !this.anchorElementScrolled &&
          this.isCommunicationAnchored() &&
          (this.isElementVisible() || this.isElementCompleted())
        ) {
          this.handleAnchorScroll(() => {
            window.history.replaceState(
              null,
              null,
              '#' + elementType + '-' + elementId
            )
            this.hash = null
          })
        }
      } else {
        window.history.replaceState(
          null,
          null,
          '#' + elementType + '-' + elementId
        )
      }
    },

    clearAnchor() {
      history.replaceState(
        '',
        document.title,
        `${window.location.pathname}${window.location.search}`
      )
    },

    isCommunicationAnchored() {
      const { type } = this.extractTypeAndId(this.elementAnchorLink())
      return ['remark', 'check-link'].includes(type)
    },

    isElementVisible() {
      const anchorElement = this.anchorElement()

      if (anchorElement && !isVisible(anchorElement))
        return Boolean(this.expandHiddenItems)

      return isVisible(anchorElement)
    },

    isElementCompleted() {
      const anchorElement = this.anchorElement()

      if (!anchorElement) {
        return false
      }

      const elementCompleted = anchorElement.classList.contains(
        'sf-commcard-completed'
      )

      return elementCompleted
    },

    anchorElement() {
      // When the including component does not have a single root element, Vue
      // creates a dummy node. In this case, we need to go through the parent.
      return this.$el.parentElement.querySelector(this.elementAnchorLink())
    },

    highlightCardBeforeScroll({ elementId, force } = { force: false }) {
      const highlightedCardStore = useHighlightedCard()

      const { type, id } = this.extractTypeAndId(elementId)
      // remark or check-link
      const card = { type, id }

      this.setAnchor({
        elementType: card.type,
        elementId: card.id,
        force,
      })

      highlightedCardStore.setHighlightedCard(card)

      return card
    },

    scrollTo(elementSelector, container, offset = 0) {
      return _scrollTo(elementSelector, container, offset)
    },

    extractTypeAndId(rawStr) {
      // normalize the string - cleanup the #, in case it's there
      const str = rawStr.replace('#', '')
      const index = str.lastIndexOf('-')

      return {
        type: str.substr(0, index),
        id: parseInt(str.substr(index + 1, str.length - 1)),
      }
    },
  },
}
